export const getCustomerBenefits = `
  query customerBenefit{
  customerBenefit{
    provider{
      name
      id
      product {
        mobile {
          product{
            id,
            text
          }
        }
        energy {
          product{
            id,
            text 
          }
        }
      }
    }
  }
}
`;

export default getCustomerBenefits;
